import type { CompRef } from '@wix/document-services-types';
import { AbstractComponentsPlatformService } from './AbstractComponentsPlatformService';

import { InnerElementsPathService } from '../sharedServices';
import type { EditorPointer } from '@wix/editor-document-logic-api';

export class InnerElementPathPlatformService extends AbstractComponentsPlatformService {
  getPath(editorPointer: EditorPointer<CompRef>, elementPath: string) {
    return new InnerElementsPathService(elementPath, {
      editorPointerAPI: this.editorPointerAPI,
      editorPointer,
    }).build();
  }

  getPointer(
    relativePointer: EditorPointer<CompRef>,
    elementPath: string,
  ): EditorPointer<CompRef> {
    const innerPath = this.getPath(relativePointer, elementPath);

    return this.editorPointerAPI.buildEditorPointer(
      this.editorPointerAPI.getDocumentPointer(relativePointer),
      innerPath ?? [],
    );
  }
}
